import StudentEnquiryForm from '../../features/commonfile/StudentEnquiryForm'

const AdminStudentEnquiry = () => {
    return (
        <>
            <StudentEnquiryForm />
        </>
    )
}

export default AdminStudentEnquiry